<div
  class="viewer"
  (click)="onBackdropClick($event)"
  (wheel)="onWheel($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp()"
  (pointerleave)="onPointerUp()"
>
  <div class="viewer__topbar">
    <span class="viewer__filename" *ngIf="filename">{{ filename }}</span>
    <button
      type="button"
      class="viewer__close"
      (click)="close()"
      matTooltip="Close"
      data-testid="image-fullscreen-close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <img
    class="viewer__image"
    [class.viewer__image--panning]="isDragging"
    [src]="url"
    [style.transform]="transform"
    [style.cursor]="scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'zoom-in'"
    alt=""
    draggable="false"
    (click)="$event.stopPropagation()"
    (dblclick)="onDoubleClick()"
    (pointerdown)="onPointerDown($event)"
    data-testid="image-fullscreen-image"
  />

  <div class="viewer__controls" (click)="$event.stopPropagation()">
    <button
      type="button"
      (click)="zoomOut()"
      [disabled]="scale <= minScale"
      matTooltip="Zoom out"
      data-testid="image-fullscreen-zoom-out"
    >
      <mat-icon>remove</mat-icon>
    </button>
    <span class="viewer__zoom-label" (click)="reset()" title="Reset zoom">
      {{ (scale * 100) | number: '1.0-0' }}%
    </span>
    <button
      type="button"
      (click)="zoomIn()"
      [disabled]="scale >= maxScale"
      matTooltip="Zoom in"
      data-testid="image-fullscreen-zoom-in"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
